import { ref } from 'vue'
import { useDropZone } from '@vueuse/core'
import { useFileFormatter } from './useFileFormatter'

export type FilePreviewCategory = 'media' | 'image' | 'video' | 'audio' | 'document' | 'all'

export const useFiles = () => {
  const { validateFileSize } = useFileFormatter()
  const previewFiles = ref<File[]>([])
  const previewCategory = ref<FilePreviewCategory>('all')
  const showFilePreviewModal = ref(false)
  const dropZoneRef = ref<HTMLElement>()

  const { isOverDropZone } = useDropZone(dropZoneRef, {
    onDrop: (files) => {
      if (files && files.length > 0) {
        const validFiles = Array.from(files).filter((file) => validateFileSize(file))
        if (validFiles.length > 0) {
          previewFiles.value = validFiles
          previewCategory.value = 'all'
          showFilePreviewModal.value = true
        }
      }
    },
  })

  const selectFiles = (files: File[], category: FilePreviewCategory = 'all') => {
    if (!files || files.length === 0) return
    const validFiles = files.filter((file) => validateFileSize(file))
    if (validFiles.length > 0) {
      previewFiles.value = validFiles
      previewCategory.value = category
      showFilePreviewModal.value = true
    }
  }

  const closeFilePreview = () => {
    previewFiles.value = []
    previewCategory.value = 'all'
    showFilePreviewModal.value = false
  }

  return {
    dropZoneRef,
    isOverDropZone,
    previewFiles,
    previewCategory,
    showFilePreviewModal,
    selectFiles,
    closeFilePreview,
  }
}
